import { useCallback, useEffect, useMemo, useState } from 'react';

import Modal from 'components/shared/Modal/Modal';

import { isSameBranding, normalizeBranding } from '../lib';

import BrandSidepanel from './BrandSidepanel';
import LivePreview from './preview/LivePreview';

const BrandColorsModal = ({ isOpen, handleClose, branding, practice, onSave, isSaving }) => {
  const savedDraft = useMemo(() => normalizeBranding(branding), [branding]);
  const [draft, setDraft] = useState(savedDraft);
  const isDirty = !isSameBranding(draft, savedDraft);

  // Re-seed from the saved selection every time the modal opens so a cancelled edit is dropped.
  useEffect(() => {
    if (isOpen) setDraft(savedDraft);
  }, [isOpen, savedDraft]);

  const handleChange = useCallback(
    (patch) => setDraft((current) => ({ ...current, ...patch })),
    []
  );

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      isDirty={isDirty}
      confirmMessage="Discard your brand color changes?"
      title="Brand colors"
      width="full"
      bodyClassName="flex min-h-0 p-0 xs:flex-col"
      footerActions={{
        // No onClick: the footer's default close goes through the unsaved-changes guard.
        secondary: { text: 'Cancel', color: 'neutral' },
        primary: {
          text: 'Save changes',
          onClick: () => (isDirty ? onSave(draft) : handleClose()),
          isLoading: isSaving,
          dataQa: 'save-brand-colors'
        }
      }}>
      <BrandSidepanel draft={draft} onChange={handleChange} />
      <LivePreview draft={draft} practice={practice} />
    </Modal>
  );
};

export default BrandColorsModal;
